// 1. Single login

// import React, { memo, useContext } from "react";
// import { Route, Routes, Navigate } from "react-router-dom";
// import { AuthenticationContext } from "../context/AuthenticationContext";
// import { Box } from "@mui/material";
// import EventLogReports from "../pages/admin/page/event_log_reports/EventLogReports";
// import MsitMain from "../pages/admin/page/msit/MsitMain";
// import StringInverter from "../pages/admin/page/msit/stringInverter/StringInverter";
// import PrivateRoute2 from "./stacks/PrivateRoute2";
// import BusinessDashboard from "../pages/admin/page/business/BusinessDashboard";
// import PlantPowerCurve from "../pages/admin/page/plantPowerCurve/PlantPowerCurve";
// import PrAnalysis from "../pages/admin/page/prAnalysis/PrAnalysis";
// import DashboardKusum from "../pages/admin/page/dashboardKusum/DashboardKusum";
// import PlantPowerCurveKusum from "../pages/admin/page/plantPowerCurveKusum/PlantPowerCurveKusum";


// const PrivateRoute = React.lazy(() => import("./stacks/PrivateRoute"));
// const Dashboard = React.lazy(() =>
//   import("../pages/admin/page/dashboard/Dashboard")
// );
// const Analysis = React.lazy(() =>
//   import("../pages/admin/page/analysis/Analysis")
// );
// const PvMonitoring = React.lazy(() =>
//   import("../pages/admin/page/pv_monitoring/PvMonitoring")
// );
// const WMS = React.lazy(() => import("../pages/admin/page/wms/WMS"));
// const PublicRoute = React.lazy(() => import("./stacks/PublicRoute"));
// const Login = React.lazy(() => import("../pages/auth/Login"));
// const EnergyReporting = React.lazy(() =>
//   import("../pages/admin/page/energy_reporting/EnergyReporting")
// );
// const Inverter = React.lazy(() =>
//   import("../pages/admin/page/inverter/Inverter")
// );
// const Inverter1 = React.lazy(() =>
//   import("../pages/admin/page/inverter1/Inverter1")
// );
// const Grid = React.lazy(() => import("../pages/admin/page/grid/Grid"));
// const DG = React.lazy(() => import("../pages/admin/page/dg/DG"));
// const EnergyMeter = React.lazy(() =>
//   import("../pages/admin/page/energy_meter/EnergyMeter")
// );
// const SMB = React.lazy(() => import("../pages/admin/page/smb/SMB"));

// const MainRouter = () => {
//   const { IsLogged, IsLoggedIn, setIsLoggedIn } = useContext(AuthenticationContext);
//   const { LoggedInUserInfo } = React.useContext(AuthenticationContext)

//   return (
//     <Routes>
//       {IsLogged ? (
//         <>
//           {/* Routes for Plant Dashboard */}
//           <Route path="/" element={<PrivateRoute />}>
//             {/* {
//               LoggedInUserInfo.USER_CATEGORY !== "KUSUM" ? (
//                 <Route index element={<Dashboard />} />
//               ) : (
//                 <Route index element={<DashboardKusum />} />
//               )
//             } */}

//             {LoggedInUserInfo.USER_CATEGORY !== "KUSUM" ? (
//               <Route path="dashboard" element={<Dashboard />} />
//             ) : (
//               <Route path="dashboard" element={<DashboardKusum />} />
//             )}

//             {/* Redirect "/" to "/dashboard" */}
//             <Route index element={<Navigate to="/dashboard" />} />


//             <Route path="wms" element={<WMS />} />
//             <Route path="inverter" element={<Inverter />} />
//             <Route path="analysis" element={<Analysis />} />
//             <Route path="inv" element={<Inverter1 />} />
//             <Route path="grid" element={<Grid />} />
//             <Route path="dg" element={<DG />} />
//             <Route path="energy-meter" element={<EnergyMeter />} />
//             <Route path="smb" element={<SMB />} />
//             <Route path="pv_monitoring" element={<PvMonitoring />} />
//             <Route path="energy" element={<EnergyReporting />} />
//             <Route path="event-log-reports" element={<EventLogReports />} />
//             <Route path="plant-power-curve" element={<PlantPowerCurve />} />
//             <Route path="PR-analysis" element={<PrAnalysis />} />
//             <Route path="plantPowerCurve" element={<PlantPowerCurveKusum />} />

//             <Route path="msit" element={<MsitMain />}>
//               <Route index element={<StringInverter />} />
//             </Route>
//             <Route path="*" element={<Box>Page Not Found plant</Box>} />
//           </Route>
//           {/* Redirect from "/" to "/plant" */}
//           {/* <Route path="/" element={<Navigate to="/plant" />} /> */}
//         </>
//       ) : (
//         <>
//           {/* Login Route */}
//           <Route path="login" element={<PublicRoute />}>
//             <Route index element={<Login />} />
//             {/* <Route path="services" element={<Services />} />
//                        <Route path="about" element={<About />} /> */}
//             <Route path="*" element={<Box>Page Not Found</Box>} />
//           </Route>
//         </>
//       )}
//     </Routes>
//   );
// };

// export default memo(MainRouter);



// 1.business Login 

// import React, { memo, useContext, Suspense, useEffect } from "react";
// import { Route, Routes, Navigate, useNavigate } from "react-router-dom";
// import { AuthenticationContext } from "../context/AuthenticationContext";
// import { BusinessAuthenticationContext } from "../context/BussinessAuthenticationContext";
// import { Box } from "@mui/material";

// import EventLogReports from "../pages/admin/page/event_log_reports/EventLogReports";
// import MsitMain from "../pages/admin/page/msit/MsitMain";
// import StringInverter from "../pages/admin/page/msit/stringInverter/StringInverter";
// import PrivateRoute2 from "./stacks/PrivateRoute2";
// import BusinessDashboard from "../pages/admin/page/business/BusinessDashboard";
// import PlantPowerCurve from "../pages/admin/page/plantPowerCurve/PlantPowerCurve";
// import PrAnalysis from "../pages/admin/page/prAnalysis/PrAnalysis";
// import DashboardKusum from "../pages/admin/page/dashboardKusum/DashboardKusum";
// import PlantPowerCurveKusum from "../pages/admin/page/plantPowerCurveKusum/PlantPowerCurveKusum";


// import BusinessInner from "../pages/admin/page/businessInner/BusinessInner";
// import Header2 from "../components/dashboard/Header2";

// import BusinessGroupForm from "../pages/admin/page/business/businessGroupFrom/BusinessGroupForm";
// import BusinessGroupListData from "../pages/admin/page/businessPageData/businessGroupList/businessGroupListData/BusinessGroupListData";
// import BusinessGroupList from "../pages/admin/page/businessPageData/businessGroupList/BusinessGroupList";
// import BusinessGroupListRight from "../pages/admin/page/businessPageData/businessGroupList/businessGroupListRight/BusinessGroupListRight";
// import BusinessLocation from "../pages/admin/page/businessPageData/businessLocation/BusinessLocation";
// import ControllingGroup from "../pages/admin/page/inverter/tabs_content/ControllingGroup";
// import ControllingGroupBottom from "../pages/admin/page/businessPageData/controllingGroup/controllingGroupBottom/ControllingGroupBottom";
// import ControllingGroupBusiness from "../pages/admin/page/businessPageData/controllingGroup/ControllingGroup";
// import Dashboard7Location from "../pages/admin/page/dashboard/dashboardTabs/tab7LocationContent/Dashboard7Location";
// import GeographicalLocation from "../pages/admin/page/geographicalLocation/GeographicalLocation";
// import AlaramLog from "../pages/admin/page/alarmLog/AlaramLog";
// import Plant1 from "../pages/admin/page/plantEnergy/plant1/Plant1";
// import Plant2 from "../pages/admin/page/plantEnergy/plant2/Plant2";
// import Plant3 from "../pages/admin/page/plantEnergy/plant3/Plant3";
// import PlantMis from "../pages/admin/page/businessPageData/plantMis/PlantMis";
// import TransformerHealth from "../pages/admin/page/transformerHealth/TransformerHealth";


// const PrivateRoute = React.lazy(() => import("./stacks/PrivateRoute"));
// const Dashboard = React.lazy(() => import("../pages/admin/page/dashboard/Dashboard"));
// const Analysis = React.lazy(() => import("../pages/admin/page/analysis/Analysis"));
// const PvMonitoring = React.lazy(() => import("../pages/admin/page/pv_monitoring/PvMonitoring"));
// const WMS = React.lazy(() => import("../pages/admin/page/wms/WMS"));
// const PublicRoute = React.lazy(() => import("./stacks/PublicRoute"));
// const Login = React.lazy(() => import("../pages/auth/Login"));
// const EnergyReporting = React.lazy(() => import("../pages/admin/page/energy_reporting/EnergyReporting"));
// const Inverter = React.lazy(() => import("../pages/admin/page/inverter/Inverter"));
// const Inverter1 = React.lazy(() => import("../pages/admin/page/inverter1/Inverter1"));
// const Grid = React.lazy(() => import("../pages/admin/page/grid/Grid"));
// const DG = React.lazy(() => import("../pages/admin/page/dg/DG"));
// const EnergyMeter = React.lazy(() => import("../pages/admin/page/energy_meter/EnergyMeter"));
// const SMB = React.lazy(() => import("../pages/admin/page/smb/SMB"));


// const MainRouter = () => {
//   const { IsLogged, LoggedInUserInfo,authLoading  } = useContext(AuthenticationContext);
//   const { IsLoggedIn,businessAuthLoading } = useContext(BusinessAuthenticationContext);
//   // const IsLoggedIn=localStorage.getItem("isLoggedIn")


//   const loginInfoData = localStorage.getItem("pass")

//   console.log("IsLoggedMain:", IsLogged, "IsLoggedInMain:", IsLoggedIn);

//   if (authLoading || businessAuthLoading) {
//     return <div>Loading...</div>;  // or a spinner
//   }

//   return (
//     <Routes>

//       {/* 🔹 Default redirect to login if no path is matched */}
//       <Route path="/" element={<Navigate to="/login" replace />} />

//       {/* 🔹 Public Routes (Login) */}
//       {!IsLogged && !IsLoggedIn ? (
//         <>
//           <Route path="/login" element={<PublicRoute />}>
//             <Route index element={<Login />} />
//             <Route path="*" element={<Navigate to="/login" replace />} />
//           </Route>

//         </>
//       ) : (
//         <>
//           {/* 🔹 Private Routes */}
//           {IsLogged && (
//             <>
//               {
//                 loginInfoData === "target" ?

//                   <Route path="/" element={<PrivateRoute />}>
//                     {
//                       loginInfoData === "target" ?
//                         <Route path="businessDashboard" element={<BusinessDashboard />} /> : null
//                     }

//                     {LoggedInUserInfo.USER_CATEGORY === "KUSUM" ? (
//                       <Route path="userDashboard" element={<DashboardKusum />} />
//                     ) : LoggedInUserInfo.USER_CATEGORY === "WMS" ? (
//                       <Route path="userDashboard" element={<WMS />} />
//                     ) : (
//                       <Route path="userDashboard" element={<Dashboard />} />
//                     )}


//                     {/* Redirect "/" to "/dashboard" */}
//                     <Route index element={<Navigate to="/userDashboard" />} />




//                     <Route path="wms" element={<WMS />} />
//                     <Route path="inverter" element={<Inverter />} />
//                     <Route path="analysis" element={<Analysis />} />
//                     <Route path="inv" element={<Inverter1 />} />
//                     <Route path="grid" element={<Grid />} />
//                     <Route path="dg" element={<DG />} />
//                     <Route path="energy-meter" element={<EnergyMeter />} />
//                     <Route path="smb" element={<SMB />} />
//                     <Route path="pv_monitoring" element={<PvMonitoring />} />
//                     <Route path="energy" element={<EnergyReporting />} />
//                     <Route path="event-log-reports" element={<EventLogReports />} />
//                     <Route path="plant-power-curve" element={<PlantPowerCurve />} />
//                     <Route path="PR-analysis" element={<PrAnalysis />} />
//                     <Route path="plantPowerCurve" element={<PlantPowerCurveKusum />} />
//                     <Route path="dashbboardLocation" element={<Dashboard7Location />} />
//                     <Route path="alaramLog" element={<AlaramLog />} />
//                     <Route path="plant1" element={<Plant1/>} />
//                     <Route path="plant2" element={<Plant2/>} />
//                     <Route path="plant3" element={<Plant3/>} />
//                     <Route path="transformerHealth" element={<TransformerHealth/>} />


//                     <Route path="geographicalLocation" element={<GeographicalLocation/>} />
//                     <Route path="*" element={<Box>Page Not Found (User)</Box>} />
//                   </Route>
//                   :
//                   <Route path="/" element={<PrivateRoute />}>
//                     {
//                       loginInfoData === "target" ?
//                         <Route path="businessDashboard" element={<BusinessDashboard />} /> : null
//                     }


//                     {/* <Route path="userDashboard" element={<Dashboard />} /> */}

//                     {/* {LoggedInUserInfo.USER_CATEGORY !== "KUSUM" ? (
//                       <Route path="userDashboard" element={<Dashboard />} />
//                     ) : (
//                       <Route path="userDashboard" element={<DashboardKusum />} />
//                     )} */}

//                     {LoggedInUserInfo.USER_CATEGORY === "KUSUM" ? (
//                       <Route path="userDashboard" element={<DashboardKusum />} />
//                     ) : LoggedInUserInfo.USER_CATEGORY === "WMS" ? (
//                       <Route path="userDashboard" element={<WMS />} />
//                     ) : (
//                       <Route path="userDashboard" element={<Dashboard />} />
//                     )}


//                     {/* Redirect "/" to "/dashboard" */}
//                     <Route index element={<Navigate to="/userDashboard" />} />

//                     <Route path="wms" element={<WMS />} />
//                     <Route path="inverter" element={<Inverter />} />
//                     <Route path="analysis" element={<Analysis />} />
//                     <Route path="inv" element={<Inverter1 />} />
//                     <Route path="grid" element={<Grid />} />
//                     <Route path="dg" element={<DG />} />
//                     <Route path="energy-meter" element={<EnergyMeter />} />
//                     <Route path="smb" element={<SMB />} />
//                     <Route path="pv_monitoring" element={<PvMonitoring />} />
//                     <Route path="energy" element={<EnergyReporting />} />
//                     <Route path="event-log-reports" element={<EventLogReports />} />
//                     <Route path="plant-power-curve" element={<PlantPowerCurve />} />
//                     <Route path="PR-analysis" element={<PrAnalysis />} />
//                     <Route path="plantPowerCurve" element={<PlantPowerCurveKusum />} />
//                     <Route path="geographicalLocation" element={<GeographicalLocation/>} />
//                     <Route path="alaramLog" element={<AlaramLog />} />
//                     <Route path="plant1" element={<Plant1/>} />
//                     <Route path="plant2" element={<Plant2/>} />
//                     <Route path="plant3" element={<Plant3/>} />
//                     <Route path="transformerHealth" element={<TransformerHealth/>} />
//                     <Route path="*" element={<Box>Page Not Found (User)</Box>} />
//                   </Route>
//               }
//             </>
//           )}
//           {
//             IsLoggedIn && (
//               <Route path="businessDashboard" element={<BusinessDashboard />}>
//                 {/* Redirect to 'businessinner' when visiting '/businessDashboard' */}
//                 <Route index element={<Navigate to="business" replace />} />
//                 <Route path="business" element={<BusinessInner />} />

//                 <Route path="businessLocation" element={<BusinessLocation/>} />
//                 <Route path="plantMis" element={<PlantMis/>} />



//                 <Route path="businessGroupList" element={<BusinessGroupList />}>

//                   <Route path="businessGroupRight" element={<BusinessGroupListRight />} />
//                 </Route>

//                 <Route path="controllingGroup" element={<ControllingGroupBusiness/>}>

//                   <Route path="controllingGroupBottom" element={<ControllingGroupBottom/>} /> 
//                 </Route>



//               </Route>


//             )}

//         </>
//       )}
//     </Routes>

//   );
// };

// export default MainRouter;


import React, { memo, useContext, Suspense, useEffect } from "react";
import { Route, Routes, Navigate, useNavigate } from "react-router-dom";
import { AuthenticationContext } from "../context/AuthenticationContext";
import { BusinessAuthenticationContext } from "../context/BussinessAuthenticationContext";
import { Box } from "@mui/material";

import EventLogReports from "../pages/admin/page/event_log_reports/EventLogReports";
import MsitMain from "../pages/admin/page/msit/MsitMain";
import StringInverter from "../pages/admin/page/msit/stringInverter/StringInverter";
import PrivateRoute2 from "./stacks/PrivateRoute2";
import BusinessDashboard from "../pages/admin/page/business/BusinessDashboard";
import PlantPowerCurve from "../pages/admin/page/plantPowerCurve/PlantPowerCurve";
import PrAnalysis from "../pages/admin/page/prAnalysis/PrAnalysis";
import DashboardKusum from "../pages/admin/page/dashboardKusum/DashboardKusum";
import PlantPowerCurveKusum from "../pages/admin/page/plantPowerCurveKusum/PlantPowerCurveKusum";


import BusinessInner from "../pages/admin/page/businessInner/BusinessInner";
import Header2 from "../components/dashboard/Header2";

import BusinessGroupForm from "../pages/admin/page/business/businessGroupFrom/BusinessGroupForm";
import BusinessGroupListData from "../pages/admin/page/businessPageData/businessGroupList/businessGroupListData/BusinessGroupListData";
import BusinessGroupList from "../pages/admin/page/businessPageData/businessGroupList/BusinessGroupList";
import BusinessGroupListRight from "../pages/admin/page/businessPageData/businessGroupList/businessGroupListRight/BusinessGroupListRight";
import BusinessLocation from "../pages/admin/page/businessPageData/businessLocation/BusinessLocation";
import ControllingGroup from "../pages/admin/page/inverter/tabs_content/ControllingGroup";
import ControllingGroupBottom from "../pages/admin/page/businessPageData/controllingGroup/controllingGroupBottom/ControllingGroupBottom";
import ControllingGroupBusiness from "../pages/admin/page/businessPageData/controllingGroup/ControllingGroup";
import Dashboard7Location from "../pages/admin/page/dashboard/dashboardTabs/tab7LocationContent/Dashboard7Location";
import GeographicalLocation from "../pages/admin/page/geographicalLocation/GeographicalLocation";
import AlaramLog from "../pages/admin/page/alarmLog/AlaramLog";
import Plant1 from "../pages/admin/page/plantEnergy/plant1/Plant1";
import Plant2 from "../pages/admin/page/plantEnergy/plant2/Plant2";
import Plant3 from "../pages/admin/page/plantEnergy/plant3/Plant3";
import PlantMis from "../pages/admin/page/businessPageData/plantMis/PlantMis";
import TransformerHealth from "../pages/admin/page/transformerHealth/TransformerHealth";
import BusinessWms from "../pages/admin/page/businessPageData/businessWms/BusinessWms";
import BusinessInnerDashboard from "../pages/admin/page/businessInner/BusinessInnerDashboard";
import Battery from "../pages/admin/page/battery/Battery";
import BusinessGroupListMain from "../pages/admin/page/businessPageData/businessGroupList/BusinessGroupListMain";
import Analytics from "../pages/admin/page/Analytics/Analytics";
import UserAnalytics from "../pages/admin/page/UserAnalytics/UserAnalytics";
import SupportForm from "../pages/admin/page/SupportForm/SupportForm";
import SupportFormMain from "../pages/admin/page/SupportForm/SupportFormMain";
import UserDetails from "../pages/admin/page/UserDetails/UserDetails";


const PrivateRoute = React.lazy(() => import("./stacks/PrivateRoute"));
const Dashboard = React.lazy(() => import("../pages/admin/page/dashboard/Dashboard"));
const Analysis = React.lazy(() => import("../pages/admin/page/analysis/Analysis"));
const PvMonitoring = React.lazy(() => import("../pages/admin/page/pv_monitoring/PvMonitoring"));
const WMS = React.lazy(() => import("../pages/admin/page/wms/WMS"));
const PublicRoute = React.lazy(() => import("./stacks/PublicRoute"));
const Login = React.lazy(() => import("../pages/auth/Login"));
const EnergyReporting = React.lazy(() => import("../pages/admin/page/energy_reporting/EnergyReporting"));
const Inverter = React.lazy(() => import("../pages/admin/page/inverter/Inverter"));
const Inverter1 = React.lazy(() => import("../pages/admin/page/inverter1/Inverter1"));
const Grid = React.lazy(() => import("../pages/admin/page/grid/Grid"));
const DG = React.lazy(() => import("../pages/admin/page/dg/DG"));
const EnergyMeter = React.lazy(() => import("../pages/admin/page/energy_meter/EnergyMeter"));
const SMB = React.lazy(() => import("../pages/admin/page/smb/SMB"));


const MainRouter = () => {
  const { IsLogged, LoggedInUserInfo, authLoading } = useContext(AuthenticationContext);
  const { IsLoggedIn, businessAuthLoading } = useContext(BusinessAuthenticationContext);
  // const IsLoggedIn=localStorage.getItem("isLoggedIn")


  const loginInfoData = localStorage.getItem("pass")

  // console.log("IsLoggedMain:", IsLogged, "IsLoggedInMain:", IsLoggedIn);

  if (authLoading || businessAuthLoading) {
    return <div>Loading...</div>;  // or a spinner
  }


  return (
    <Routes>

      {/* 🔹 Default redirect to login if no path is matched */}
      <Route path="/" element={<Navigate to="/login" replace />} />

      {/* 🔹 Public Routes (Login) */}
      {!IsLogged && !IsLoggedIn ? (
        <>
          <Route path="/login" element={<PublicRoute />}>
            <Route index element={<Login />} />
            <Route path="*" element={<Navigate to="/login" replace />} />
          </Route>

        </>
      ) : (
        <>
          {/* 🔹 Private Routes */}
          {IsLogged && (
            <>
              {
                loginInfoData === "target" ?

                  <Route path="/" element={<PrivateRoute />}>
                    {
                      loginInfoData === "target" ?
                        <Route path="businessDashboard" element={<BusinessDashboard />} /> : null
                    }

                    {LoggedInUserInfo.USER_CATEGORY?.trim() === "KUSUM" ? (
                      <Route path="userDashboard" element={<DashboardKusum />} />
                    ) : LoggedInUserInfo.USER_CATEGORY?.trim() === "WMS" ? (
                      <Route path="userDashboard" element={<WMS />} />
                    ) : (
                      <Route path="userDashboard" element={<Dashboard />} />
                    )}



                    {/* Redirect "/" to "/dashboard" */}
                    <Route index element={<Navigate to="/userDashboard" />} />




                    <Route path="wms" element={<WMS />} />
                    <Route path="inverter" element={<Inverter />} />
                    <Route path="analysis" element={<Analysis />} />
                    <Route path="inv" element={<Inverter1 />} />
                    <Route path="grid" element={<Grid />} />
                    <Route path="dg" element={<DG />} />
                    <Route path="energy-meter" element={<EnergyMeter />} />
                    <Route path="smb" element={<SMB />} />
                    <Route path="pv_monitoring" element={<PvMonitoring />} />
                    <Route path="energy" element={<EnergyReporting />} />
                    <Route path="event-log-reports" element={<EventLogReports />} />
                    <Route path="plant-power-curve" element={<PlantPowerCurve />} />
                    <Route path="PR-analysis" element={<PrAnalysis />} />
                    <Route path="plantPowerCurve" element={<PlantPowerCurveKusum />} />
                    <Route path="dashbboardLocation" element={<Dashboard7Location />} />
                    <Route path="alaramLog" element={<AlaramLog />} />
                    <Route path="plant1" element={<Plant1 />} />
                    <Route path="plant2" element={<Plant2 />} />
                    <Route path="plant3" element={<Plant3 />} />
                    <Route path="transformerHealth" element={<TransformerHealth />} />
                    <Route path="battery" element={<Battery />} />
                    <Route path="analytics" element={<UserAnalytics/>} />
                    {/* <Route path="supportform" element={<SupportForm/>} /> */}
                    <Route path="supportform" element={<SupportFormMain/>} />
                    <Route path="userdetails" element={<UserDetails/>} />
                    
                    <Route path="geographicalLocation" element={<GeographicalLocation />} />
                    <Route path="*" element={<Box>Page Not Found (User)</Box>} />
                  </Route>
                  :
                  <Route path="/" element={<PrivateRoute />}>
                    {
                      loginInfoData === "target" ?
                        <Route path="businessDashboard" element={<BusinessDashboard />} /> : null
                    }


                    {LoggedInUserInfo.USER_CATEGORY?.trim() === "KUSUM" ? (
                      <Route path="userDashboard" element={<DashboardKusum />} />
                    ) : LoggedInUserInfo.USER_CATEGORY?.trim() === "WMS" ? (
                      <Route path="userDashboard" element={<WMS />} />
                    ) : (
                      <Route path="userDashboard" element={<Dashboard />} />
                    )}



                    {/* Redirect "/" to "/dashboard" */}
                    <Route index element={<Navigate to="/userDashboard" />} />

                    <Route path="wms" element={<WMS />} />
                    <Route path="inverter" element={<Inverter />} />
                    <Route path="analysis" element={<Analysis />} />
                    <Route path="inv" element={<Inverter1 />} />
                    <Route path="grid" element={<Grid />} />
                    <Route path="dg" element={<DG />} />
                    <Route path="energy-meter" element={<EnergyMeter />} />
                    <Route path="smb" element={<SMB />} />
                    <Route path="pv_monitoring" element={<PvMonitoring />} />
                    <Route path="energy" element={<EnergyReporting />} />
                    <Route path="event-log-reports" element={<EventLogReports />} />
                    <Route path="plant-power-curve" element={<PlantPowerCurve />} />
                    <Route path="PR-analysis" element={<PrAnalysis />} />
                    <Route path="plantPowerCurve" element={<PlantPowerCurveKusum />} />
                    <Route path="geographicalLocation" element={<GeographicalLocation />} />
                    <Route path="alaramLog" element={<AlaramLog />} />
                    <Route path="plant1" element={<Plant1 />} />
                    <Route path="plant2" element={<Plant2 />} />
                    <Route path="plant3" element={<Plant3 />} />
                    <Route path="transformerHealth" element={<TransformerHealth />} />
                    <Route path="battery" element={<Battery />} />

                    <Route path="analytics" element={<UserAnalytics/>} />
                    <Route path="userdetails" element={<UserDetails/>} />
                   <Route path="supportform" element={<SupportFormMain/>} />
                    
                    <Route path="*" element={<Box>Page Not Found (User)</Box>} />
                  </Route>
              }
            </>
          )}
          {
            IsLoggedIn && (
              <Route path="businessDashboard" element={<BusinessDashboard />}>
                {/* Redirect to 'businessinner' when visiting '/businessDashboard' */}
                <Route index element={<Navigate to="business" replace />} />
                <Route path="business" element={<BusinessInnerDashboard/>} />

                <Route path="businessLocation" element={<BusinessLocation />} />
                <Route path="plantMis" element={<PlantMis />} />

                <Route path="businessWms" element={<BusinessWms />} />

                <Route path="businessGroupList" element={<BusinessGroupListMain/>}>

                  <Route path="businessGroupRight" element={<BusinessGroupListRight />} />
                </Route>

                <Route path="controllingGroup" element={<ControllingGroupBusiness />}>

                  <Route path="controllingGroupBottom" element={<ControllingGroupBottom />} />
                </Route>
                <Route path="analytics" element={<Analytics/>} />


              </Route>


            )}

        </>
      )}
    </Routes>

  );
};

export default MainRouter;